import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@atgis/ui";
import {
  Boxes,
  FolderTree,
  Handshake,
  KeyRound,
  Network,
  Shapes,
  ShieldCheck,
  UserCog,
} from "lucide-react";
import { SectionHeading } from "../components/SectionHeading";

const FEATURES = [
  {
    icon: Shapes,
    title: "Kurumsal veri modeli",
    description:
      "Şebekenizdeki varlık tiplerini (vana, boru, branşman, abone…), geometrilerini (nokta, çizgi, alan) ve özniteliklerini bir kez tanımlayın. Tüm katmanlarda zorunlu olan ortak öznitelikler ile her varlığa özel alanları ayrı ayrı yönetin.",
  },
  {
    icon: Handshake,
    title: "Partner kütüphanesi",
    description:
      "Müteahhit, taşeron, kurum gibi partnerleri merkezi katalogda tut. Öznitelikler partner kataloğundan referans alır; saha kullanıcısı serbest metin yerine listeden seçer, veri tutarlı kalır.",
  },
  {
    icon: FolderTree,
    title: "Sınırsız hiyerarşik ekipler",
    description:
      "Root team altında istediğiniz derinlikte alt ekip kurun. Yetki ve görev panosu paylaşımları team ağacı üzerinden işler.",
  },
  {
    icon: UserCog,
    title: "Ekibe özel öznitelik varsayılanları",
    description:
      "Bir ekibin sahada hangi varlık tiplerine hangi varsayılan değerleri yazacağını veri modeline göre tanımlayın. Alan kilitlenirse otomatik dolar, açık bırakılırsa kullanıcı düzenler — saha hatası baştan engellenir.",
  },
  {
    icon: KeyRound,
    title: "Coğrafi sınırlı yetki",
    description:
      "Düzenleme / saha düzenlemesi / yalnızca görüntüleme seviyelerini kullanıcı veya ekibe atayın; istediğinizde harita üzerinde sınır çizin, istediğinizde varlık tipiyle filtreleyin. Yetki, veritabanı seviyesinde uygulanır.",
  },
  {
    icon: Boxes,
    title: "Workspace ile ekip projeleri",
    description:
      "Pro kullanıcılar workspace açar, üye davet eder, serbest projelerini ortak alanda paylaşır. Depolama ve üye sayısı plan bazında.",
  },
  {
    icon: ShieldCheck,
    title: "Role göre uyarlanan arayüz",
    description:
      "Her kullanıcı sadece yetkisi olduğu menüleri, butonları ve projeleri görür. Saha ekibi yönetim ekranlarıyla, yöneticiler de saha formlarıyla karşılaşmaz; ekran rolünüze göre sadeleşir.",
  },
  {
    icon: Network,
    title: "Realtime durum",
    description:
      "Revizyon onayı, üye daveti, görev ataması gibi olaylar ilgili kullanıcının ekranına anlık olarak yansır — sayfa yenilemeye gerek yok.",
  },
];

export function Capabilities() {
  return (
    <section id="yetenekler" className="border-b border-border/60 bg-card/30">
      <div className="container py-20 md:py-28">
        <SectionHeading
          eyebrow="Platform Yetenekleri"
          title={
            <>
              Kurumsal CBS için <span className="gradient-text">eksiksiz set</span>.
            </>
          }
          description="Veri modeli, organizasyon, yetkilendirme ve operasyonel takip — hepsi tek platformda, hepsi kurumun veri modeline bağlı."
        />

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {FEATURES.map(({ icon: Icon, title, description }) => (
            <Card key={title} className="h-full">
              <CardHeader>
                <div className="grid h-9 w-9 place-items-center rounded-lg bg-muted">
                  <Icon className="h-4 w-4 text-foreground/80" />
                </div>
                <CardTitle className="mt-3 text-base">{title}</CardTitle>
                <CardDescription className="text-sm">{description}</CardDescription>
              </CardHeader>
              <CardContent />
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
